import React, {useEffect} from 'react';
import {jsPDF} from 'jspdf';
import {connect} from 'react-redux'
import autoTable from 'jspdf-autotable';
import addFont from '../../../assets/fonts/fonts';
import { getCandidatInfoTrash } from '../../../actions/grants';
import moment from 'moment';
import { grantsNames } from '../../../utils/const';

// Ориентация и опции для текста
const orientation = 'p';
const option = {
    maxWidth: 180,
    align: 'center'
};

const optionR = {
    maxWidth: 180,
    align: 'right'
};

const mapStateToProps = ({grants}) => {
    const {
        candidatInfo,
        loading_candidatInfo,
        chief
    } = grants;
    return {
        candidatInfo,
        loading_candidatInfo,
        chief
    }
}

const ScholarshipTable = ({
    candidatInfo,
    loading_candidatInfo,
    getCandidatInfoTrash,
    chief,
    year,
    heads,
    setHeads,
    GOU
    }) => {

    // Генерация PDF
    const generatePDF = async(tables) => {
        // Добавление шрифта
        addFont(jsPDF.API);

        // Создание документа
        const doc = new jsPDF({orientation});

        // Установка шрифта для основного текста
        doc.setFont('TimesNewRomanBold');
        doc.setFontSize(16);
        
        let currentY = 10;
        
        // if (doc.pageCount > 1) {
            // doc.text(doc.pageCount, 105, 10, option);
            // }
        
        // Заголовок документа
        doc.text('ОБЩИЕ СВЕДЕНИЯ', 105, currentY + 6, option);
        doc.setFontSize(14);
        doc.text('о кандидате на именную стипендию', 105, currentY + (6 * 2), option);
        doc.text('Министерства обороны Российской Федерации', 105, currentY + (6 * 3), option);
        doc.text('для курсантов, слушателей и адъюнктов федеральных', 105, currentY + (6 * 4), option);
        doc.text('государственных организаций, осуществляющих', 105, currentY + (6 * 5), option);
        doc.text('образовательную деятельность и находящихся в ведении', 105, currentY + (6 * 6), option);
        doc.text('Министерства обороны Российской Федерации', 105, currentY + (6 * 7), option);

        currentY += 48;

        
        const tableColumnWidths = {
            0: { cellWidth: 0.07 * doc.internal.pageSize.width, halign: 'center' }, // 10% ширины страницы
            1: { cellWidth: 0.6  * doc.internal.pageSize.width - 14, halign: 'left' }, // 30% ширины страницы
            2: { cellWidth: 0.33 * doc.internal.pageSize.width - 14, halign: 'center' }  // 60% ширины страницы
        };

        const headerData = [
            [` №  п/п`, 'Наименование сведений', 'Сведения о кандидате'],
            ['1', '2', '3'],
        ]

        // Генерация таблиц
        tables.forEach((table, index) => {

            // Добавляем таблицу
            autoTable(doc, {
                head: index === 0 ? headerData : null,
                body: table,
                startY: currentY,
                columnStyles: tableColumnWidths,
                didDrawPage: function (data) {
                    // Получаем номер текущей страницы
                    const currentPageNumber = doc.getCurrentPageInfo().pageNumber;
                
                    // Добавляем номер страницы, но только если это не первая страница
                    if (currentPageNumber > 1) {
                        doc.setFont('TimesNewRoman');
                        doc.setFontSize(16);
                        doc.text(`${currentPageNumber}`, 105, 10, option);
                    }
                  },
                styles: {
                    font: "TimesNewRoman",
                    fontSize: 14, // Уменьшенный размер шрифта для строгого вида
                    cellPadding: 2, // Меньший отступ в ячейках
                    valign: 'middle', // Вертикальное выравнивание текста
                    halign: 'center',
                    lineWidth: 0.1, // Тонкие границы ячеек
                    lineColor: [
                        0, 0, 0
                    ], // Чёрный цвет границ
                    cellWidth: 'wrap'
                },
                headStyles: {
                    fillColor: [
                        255, 255, 255
                    ], // Светло-серый цвет для заголовков
                    textColor: [
                        0, 0, 0
                    ], // Чёрный текст заголовков
                    fontStyle: 'bold', // Жирный текст в заголовках
                },
                alternateRowStyles: {
                    fillColor: [
                        255, 255, 255
                    ], // Очень светлый серый для чередующихся строк
                },
                tableLineColor: [
                    0, 0, 0
                ], // Цвет линий таблицы
                bodyStyles: {
                    textColor: [
                        0, 0, 0
                    ], // Чёрный цвет линий
                },
                tableLineWidth: 0.1, // Толщина линий таблицы
            });

            currentY = doc.lastAutoTable.finalY;

            if (currentY > 240) {
                doc.addPage();
                currentY = 15;
                if (doc.pageCount > 1) {
                    doc.text(doc.pageCount, 105, 5, option);
                }
            }
        });

        doc.setFont('TimesNewRoman');
        doc.setFontSize(16);

        // Заключительная часть
        // doc.text(`Подписант`, 60, currentY + 14, option);
        doc.text(`${heads[0].post}`, 105, currentY + 14, option);
        doc.text(`${heads[0].rank}                                   ${heads[0].name}`, 105, currentY + 20, option);
        doc.text(`${heads[0]?.date ? moment(heads[0]?.date).format('D MMMM YYYY г.') : '   '}`, 70, currentY + 28, option);
        

        doc.setFontSize(12);
        // doc.text('1', 33, 289);
        // doc.text('Укразывается в характеристике-рекомендации и в служебной характеристике', 105, 290, option);
        doc.setFontSize(16);
        
        // Сохранение PDF
        doc.save(`Общие сведения ${candidatInfo.lastname }  ${candidatInfo.firstname.charAt()}.${candidatInfo.patronymic.charAt()}.pdf`);
        setHeads([])
    };

    // const transformDatas = (data) => {
    //     const result = [];
    //     let currentTitle = null;
    //     let currentGroup = [];
    //     let count = 12;
    
    //     data.forEach(item => {
    //         const title = item.title;
    //         const indicatorTitle = item.indicator_title;
    //         const sumValue = item.sum_value;
    //         const value = item.value;
    
    //         if (title !== currentTitle) {
    //             count = count + 1;
    //             if (currentGroup.length > 0) {
    //                 result.push(currentGroup);
    //             }
    //             currentGroup = [
    //                 // [count, title, sumValue],
    //                 ['', indicatorTitle, isZero(value)]
    //             ];
    //             currentTitle = title;
    //         } else {
    //             currentGroup.push(['', indicatorTitle, isZero(value)]);
    //         }
    //     });
    
    //     if (currentGroup.length > 0) {
    //         result.push(currentGroup);
    //     }
    
    //     return result;
    // }

    // const getListByParentId = (data, id) => {
    //     let list = [];
    //     data.forEach(item => {
    //         if (item.indicator_id == id) {
    //             list.push(item);
    //         }
    //     });
    //     return list;
    // }
    
    // const getOtherList = (data) => {
    //     let list = [];
    //     let Idlist = [ 3669, 3636, 3652, 3663, 3658, 3693, 3508, 3514, 3709, 3575, 3520, 3526, 3531, 3681, 3687, 3694 ];

    //     data.forEach(item => {
    //         if (!Idlist.includes(item.previous_level_id)) {
    //             list.push(item);
    //         }
    //     });
    //     return list;
    // }

    // const getValues = (data) => {
    //     let value = 0;
    //     data.forEach(item => {
    //             value = value + Number(item.value)
    //     });
    //     return Number(value);
    // }

    const isZero = (value) => {
        return value == 0 ? 'Отсутствует' : value
    }

    const getGrantsList = (data) => {
        let grantsText = '';
        if (data?.length > 0) {
            grantsText = `Достоин присуждения ${data?.map(pr =>  grantsNames[pr?.scholarship_type])}`;
        } else {
            grantsText = 'Выберите значение стипендии';
        }
        return grantsText;
    }

    const transformData = (data) => {
        const tables = [];

        tables.push([['1', 'Учебный год (на который назначается стипендия)', year]]);
        tables.push([['2', 'Орган военного управления, которому подчинена образовательная (научная) организация', data.ovu_name]]);
        tables.push([['3', 'Наименование организации', GOU]]);
        tables.push([['4', 'Должность кандидата', data.prep_struc_category]]);
        tables.push([['5', 'Курс обучения (по состоянию на 1 сентября учебного года, на который назначается стипендия)', `${data.kurs + ' год'}`]]);
        tables.push([['6', 'Воинское звание', data.mil_rank]]);
        tables.push([['7', 'Фамилия', data.lastname], 
            ['', 'Имя', data.firstname], 
            ['', 'Отчество (при наличии)', data.patronymic]]);
            tables.push([[
                '8', 
                'Выписка из протокола заседания ученого (научного, научно-технического) совета (краткий вывод)', 
                getGrantsList(data?.grants?.filter(gr => gr?.scholarship_type != 'Исключить'))
                ]]);
            tables.push([['9', 'Характеристика-рекомендация (отзыв научного руководителя)', 'Научные достижения']]);
            tables.push([['10', 'Служебная характеристика (краткий вывод)', getGrantsList(data?.grants?.filter(gr => gr?.scholarship_type != 'Исключить'))]]);
            tables.push([['11', 'Результаты промежуточной аттестации за учебный год, предшествующий учебному году назначения стипендии, средний бал', isZero(data?.average_grade)],
            ['', 'всего оценок, в том числе:', isZero(data?.five_count + data?.four_count) ],                
            ['', '«отлично»', isZero(data?.five_count)],                
            ['', '«хорошо»', isZero(data?.four_count)],                
        ]);

        tables.push([['12', 'Академические задолженности', 'Отсутствуют']]);
        tables.push([['13', 'Достижения за период освоения образовательной программы в научной (научно-исследовательской, научно-практической) деятельности - постоянное значение. количество публикаций, всего', ''],
            ['', 'количество публикаций, всего:', isZero(data.honours.find(el => el.previous_level_id === 130)?.sum_value)],
            ['', 'в том числе:', ''],
            ...(data.honours.find(el => el.previous_level_id === 130)?.indicators.map(el => ['', el.indicator_title, isZero(el.value),]))
        ]);
        tables.push([['14', 'Наличие гранта на выполнение научно-исследовательской работы', isZero(data.honours.find(el => el.previous_level_id === 140).sum_value)],
    ]);
        tables.push([['15', 'Достижения в учебе и науке, всего', isZero(data.honours.find(el => el.previous_level_id === 150)?.sum_value)],
            ['', 'в том числе:', ''],
            ['', `1) ${data.honours.find(el => el.previous_level_id === 151)?.previous_level_title}`, isZero(data.honours.find(el => el.previous_level_id === 151)?.sum_value)],
            ...(data.honours.find(el => el.previous_level_id === 151)?.indicators.map(el => ['', el.indicator_title, isZero(el.value),])),
            ['', `2) ${data.honours.find(el => el.previous_level_id === 152)?.previous_level_title}`, isZero(data.honours.find(el => el.previous_level_id === 152)?.sum_value)],
            ...(data.honours.find(el => el.previous_level_id === 152)?.indicators.map(el => ['', el.indicator_title, isZero(el.value),])),
            ['', `3) ${data.honours.find(el => el.previous_level_id === 153)?.previous_level_title}`, isZero(data.honours.find(el => el.previous_level_id === 153)?.sum_value)],
            ...(data.honours.find(el => el.previous_level_id === 153)?.indicators.map(el => ['', el.indicator_title, isZero(el.value),]))
        ]);
        tables.push([['16', 'Служебная карточка, количество поощрений за период обучения, всего', isZero(data.honours.find(el => el.previous_level_id === 160)?.sum_value)],
            ['', 'в том числе:', ''],
            ...(data.honours.find(el => el.previous_level_id === 160)?.indicators.map(el => ['', el.indicator_title, isZero(el.value),]))
        ]);
        tables.push([['17', 'Иные достижения в учебной и (или) научной деятельности, всего', isZero(data.honours.find(el => el.previous_level_id === 170)?.sum_value)],
            ['', 'в том числе:', ''],
            ...(data.honours.find(el => el.previous_level_id === 170)?.indicators.map(el => ['', el.indicator_title, isZero(el.value),]))
        ]);

        // tables.push([['13', 'Достижения за период освоения образовательной программы, в научной (научно-исследовательской, научно-практической) деятельности ', '']]);
        // tables.push([['', 'количество публикаций, всего', '8']]);
        // tables.push([['', 'в том числе:', '']]);
        // tables.push([['', 'в рецензируемых научных изданиях, рекомендованных ВАК', '1']]);
        // tables.push([['', 'в материалах конференций', '6']]);
        // tables.push([['', 'в периодических изданиях организации', '1']]);
        // transformDatas(getListByParentId(data.honours, 3669)).map(el => tables.push(el));
        // tables.push([['13', 'Наличие гранта на выполнение научно-исследовательской работы', isZero(getValues(getListByParentId(data.honours, 3694)))]]);
        // tables.push([['14', 'Достижения в учебе и науке всего,', 
        //     isZero(getValues(getListByParentId(data.honours, 3636)) +
        //     getValues(getListByParentId(data.honours, 3652)) +
        //     getValues(getListByParentId(data.honours, 3663)) +
        //     getValues(getListByParentId(data.honours, 3658)) +
        //     getValues(getListByParentId(data.honours, 3693)) +
        //     getValues(getListByParentId(data.honours, 3508)) +
        //     getValues(getListByParentId(data.honours, 3520)) +
        //     getValues(getListByParentId(data.honours, 3526)) +
        //     getValues(getListByParentId(data.honours, 3531))) 
        // ]]);
        // tables.push([['', 'в том числе:', '']]);
        
        // tables.push([['14.1', 'Участие в олимпиадах всего,', isZero(getValues(getListByParentId(data.honours, 3636)))]]);
        // tables.push([['', 'в том числе:', '']]);
        // transformDatas(getListByParentId(data.honours, 3636)).map(el => tables.push(el));
        
        // tables.push([['14.2', 'Участие в работе конференций, симпозиумов, семинарах, выставкахи т.п. всего,', isZero(getValues(getListByParentId(data.honours, 3652)))]]);
        // tables.push([['', 'в том числе:', '']]);
        // transformDatas(getListByParentId(data.honours, 3652)).map(el => tables.push(el));

        // tables.push([['14.3', 'Наличие научных и учебно-методических работ всего,', isZero(getValues(getListByParentId(data.honours, 3663)) + getValues(getListByParentId(data.honours, 3658)))]]);
        // tables.push([['', 'в том числе:', '']]);
        // transformDatas(getListByParentId(data.honours, 3663)).map(el => tables.push(el));
        // transformDatas(getListByParentId(data.honours, 3658)).map(el => tables.push(el));

        // tables.push([['14.4', 'Участие в научных и других конкурсах различного уровня', 
        //     isZero(getValues(getListByParentId(data.honours, 3693)) + 
        //     getValues(getListByParentId(data.honours, 3508)) + 
        //     getValues(getListByParentId(data.honours, 3514)) +
        //     getValues(getListByParentId(data.honours, 3520)) +
        //     getValues(getListByParentId(data.honours, 3526)) +
        //     getValues(getListByParentId(data.honours, 3531)) +
        //     getValues(getListByParentId(data.honours, 3687)))
        // ]]);
        // tables.push([['', 'в том числе:', '']]);
        // transformDatas(getListByParentId(data.honours, 3693)).map(el => tables.push(el));
        // transformDatas(getListByParentId(data.honours, 3508)).map(el => tables.push(el));
        // transformDatas(getListByParentId(data.honours, 3514)).map(el => tables.push(el));
        // transformDatas(getListByParentId(data.honours, 3520)).map(el => tables.push(el));
        // transformDatas(getListByParentId(data.honours, 3526)).map(el => tables.push(el));
        // transformDatas(getListByParentId(data.honours, 3531)).map(el => tables.push(el));

        // tables.push([['15', 'Обладание командными, методическими навыками и навыками воспитательной работы', isZero(getValues(getListByParentId(data.honours, 3709)))]]);
        // transformDatas(getListByParentId(data.honours, 3709)).map(el => tables.push(el));

        // tables.push([['16', 'Служебная карточка', isZero(getValues(getListByParentId(data.honours, 3575)))],
        //     ['', 'Дисциплинарные взыскания', 'Отсутствуют'],
        //     ['', 'Количество поощрений за период обучения всего,', ''],
        //     ['', 'в том числе,', '']
        // ]);
        // transformDatas(getListByParentId(data.honours, 3575)).map(el => tables.push(el));

        // tables.push([['17', 'Иные достижения в учебной и (или) научной деятельности ', 'Отсутствуют']]);
        // transformDatas(getOtherList(data.honours)).map(el => tables.push(el));

        return tables;
    };    


    const handleGeneratePDF = (data) => {
        const transformedData = transformData(data);
        generatePDF(transformedData);
        getCandidatInfoTrash();
    };

    useEffect(() => {
        candidatInfo && handleGeneratePDF(candidatInfo)
    }, [candidatInfo]);

    return (
        <div/>
    );
};

export default connect(mapStateToProps, {getCandidatInfoTrash})(ScholarshipTable)